import {  Grid } from '@mui/material';
import { useEffect, useState, lazy } from 'react';
import landingBackArrow from '../../assets/landingBackArrow.svg';
import { usePepwiseAuthController } from 'Context/contexts/AuthContext';
import IBPLogo from '../../assets/ibp.svg';
import { useTheme } from "@mui/material/styles";
import { hideIBPExec, hideMDIPExec } from '../../service/config'


// Lazy load components
const Header = lazy(() => import('./Header'));
const Footer = lazy(() => import('../LandingPage/ModuleLandingFooter'));
const capabilitiesNew : any = localStorage.getItem('capabilities');



export default function ProgramExecutiveLanding() {
	const theme= useTheme();
	const colors = theme.palette;
	const [, setMemberData] = useState<any>(null);
	const [controller, _] = usePepwiseAuthController();
	const { accessToken } = controller;
	const capabilitiesArray = capabilitiesNew.split(',')

	// to display data
	useEffect(() => {
		setMemberData(accessToken);
	}, []);

	//navigate to data-pipeline observability
	const handleDataPipelineClick = (event: any, type: string, url: string) => {
		event.preventDefault(); // Prevent the default context menu from showing up
		if (type === 'blank') {
			// Open the URL in a new tab if type is 'blank'
			window.open(url, '_blank');
		} else {
			// Navigate to the provided URL in the current tab
			window.location.href = url;
		}
	};

	const handleBackClick = () => {
		window.location.href = '/LandingPage';
	};


	return (
		<div className="outerLandingPageContainer" style={{ backgroundColor: `${colors.backgroundLight.primary}` }}>
			{/* <Header memberData={memberData} /> */}
			<div style={{ maxWidth: '86%', margin: '0 auto' }}>
				<div className="landingMessage-container">
					<img src={landingBackArrow} alt="CCLogo" className="landingMessageImage" onClick={handleBackClick} />
					<p className="landingMessage" style={{ color: `${colors.textLight.secondary}` }}>{`Program Executive Dashboard`}</p>
				</div>

				<div className="welcome_text">
					<p style={{ color: `${colors.textLight.secondary}` }}>Click on the module below to monitor!</p>
				</div>
				<Grid container spacing={1} style={{ marginTop: '0px' }}>
					{capabilitiesArray.includes('IBP') && !hideIBPExec ? (
						<Grid
							item
							xs={4}
							style={{ cursor: 'pointer' }}
							onClick={(e) => handleDataPipelineClick(e, 'no-blank', '/ibp/pipelines')}
							onContextMenu={(e) => {
								e.preventDefault();
								handleDataPipelineClick(e, 'blank', '/ibp/pipelines');
							}}
						>
							<div className="observalbility_screens" style={{ textAlign: 'center' }}>
								<div className="title">
									<img
										src={IBPLogo}
										alt="CCLogo"
										className="obs_logo"
										style={{ display: 'block', margin: '0 auto' }}
									/>
								</div>
								<div>
									<h3 className="obsTitle" style={{ margin: '10px 0' }}>
									Integrated Business Planning (IBP)
									</h3>
								</div>
								<p
									className="message1"
									title="Monitoring the IBP Turkey data landscape across the EDAP platforms leveraged."
									style={{ margin: '0', textAlign: 'center' }}
								>
									Monitoring the IBP Turkey data landscape across the EDAP platforms leveraged.
								</p>
							</div>
						</Grid>
					) : (
						''
					)}
					{capabilitiesArray.includes('MDIP') && !hideMDIPExec ? (
					<Grid
						item
						xs={4}
						onClick={(e) => handleDataPipelineClick(e, 'no-blank', '/mdip/dashboard')}
						onContextMenu={(e) => {
							e.preventDefault();
							handleDataPipelineClick(e, 'blank', '/mdip/dashboard');
						}}
					>
						<div className="observalbility_screens" style={{ textAlign: 'center' }}>
							<div className="title">
								<img
									src={IBPLogo}
									alt="tableauLogo"
									className="obs_logo"
									style={{ display: 'block', margin: '0 auto' }}
								/>
							</div>
							<div>
								<h3 className="obsTitle" style={{ margin: '10px 0' }}>
								MDIP Executive Dashboard
								</h3>
							</div>
							<p
								className="message1"
								title="Real-time dashboard-key metrics & insights for strategic decisions."
								style={{ margin: '0', textAlign: 'center' }}
							>
								Real-time dashboard-key metrics & insights for strategic decisions.
							</p>
						</div>
					</Grid>
					) : (
						''
					)}
				</Grid>
			</div>
			<Footer />
		</div>
	);
}
